import { render, staticRenderFns } from "./SdsLayout.vue?vue&type=template&id=54388aee"
import script from "./SdsLayout.vue?vue&type=script&lang=js"
export * from "./SdsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports